import React, {useState, useRef, useEffect} from 'react';
import './chatbot.css';
import chatbot from "../../assets/chatbot.webp";

function Chatbot() {

    const [questions] = useState([
        {
            name: "How do I open a new account?",
            info: "The fastest and easiest way to open an account with ChoiceTrade is to sign up online. You can also request a new account pack by email or download the required form directly from our website."
        },
        {
            name: "How do I fund my account?",
            info: "There are many different ways to fund your account. Visit our Funding Page for information on the different options that we offer."
        },
        {
            name: "Is the mobile application free?",
            info: "The ChoiceTrade Mobile Application is free for ChoiceTrade users. Trades are charged as applicable - see our commissions page."
        },
        {
            name: "Where do I go to download the app?",
            info: "There is nothing to download! Simply point your mobile browser to m.choicetrade.com."
        },
        {
            name: "Which mobile devices do you support?",
            info: "The ChoiceTrade app is currently supported on all Apple and Android mobile devices. In addition, our mobile website is available to any device with a web browser."
        }
    ]);

    const [selectedQuestionInfo, setSelectedQuestionInfo] = useState(null);
    const [isChatbotOpen, setIsChatbotOpen] = useState(false);
    const chatbotRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (chatbotRef.current && !chatbotRef.current.contains(event.target)) {
                setIsChatbotOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const openChatbot = () => {
        setIsChatbotOpen(!isChatbotOpen);
    };

    const getQuestionInfo = (questionName) => {
        const question = questions.find((d) => d.name === questionName);
        if (question) {
            setSelectedQuestionInfo(question.info);
        } else {
            setSelectedQuestionInfo("Drone information not found.");
        }
    };

    return (
        <div>
            <img
                onClick={openChatbot}
                width="60"
                height="auto"
                src={chatbot}
                alt="message-bot"
                className="chatbot_icon fixed cursor-pointer"
            />

            {isChatbotOpen && (
                <div
                    ref={chatbotRef}
                    className="chatbot flex flex-column justify-content-between fixed p-3 sm:w-25rem w-20rem h-25rem z-5"
                >
                    <div className="questions-list">
                        <ul>
                            {questions.map((question) => (
                                <li key={question.name} onClick={() => getQuestionInfo(question.name)}
                                    className="questions p-2 text-center font-medium mb-3 cursor-pointer list-none"
                                >
                                    {question.name}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="font-medium text-base">
                        <p>{selectedQuestionInfo || "Select a question to see its information."}</p>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Chatbot;